require('./openYoungCardBudget.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const moment = require('moment');
const { withRouter } = require('react-router-dom');

// @components
const OpenYoungCardBudgetFilter = require('./openYoungCardBudgetFilter/openYoungCardBudgetFilter');

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { EmptyState } = require('commonsComponents/emptyState');
const { LoadingSection } = require('commonsComponents/loadingSection');
const ComparativeCircle = require('components/commons/comparativeCircle/comparativeCircle');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const currencyHelper = require('utilities/currencyHelper');

// @constants
const { EURO_SYMBOL, DATE_FORMAT_API, BY_BUDGETS } = require('constants/index');
const { THRESHOLD_RATIO_LIMIT_BELOW_75, THRESHOLD_RATIO_LIMIT_BELOW_100 } = require('constants/comparativeCircle');
const { getCategoryIcon } = require('constants/categories');

const expenseThresholds = [{
        threshold: THRESHOLD_RATIO_LIMIT_BELOW_75,
        className: 'below-seventy-five'
    },{
        threshold: THRESHOLD_RATIO_LIMIT_BELOW_100,
        className: 'below-hundred'
    }];
const thresholdAboveHundredClassName = 'above-hundred';

class OpenYoungCardBudget extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filterSettingsOpen: false
        }
        this.handleToggleFilters = this.handleToggleFilters.bind(this);
        this.handleFilterSubmitClick = this.handleFilterSubmitClick.bind(this);
        this.handleRetry = this.handleRetry.bind(this);
    }

    determineColorClassForExpenseBudgetRatio(budget, expense) {
        const expenseToBudgetRatio = expense / budget;
        const inputRatioBelowThresholdColorData = expenseThresholds.find(thresholdData => expenseToBudgetRatio < thresholdData.threshold);
        let valueToReturn;

        if (budget === 0) {
            valueToReturn = expenseThresholds[0] && expenseThresholds[0].color;
        }

        if (!inputRatioBelowThresholdColorData) {
            valueToReturn = thresholdAboveHundredClassName;
        } else {
            valueToReturn = inputRatioBelowThresholdColorData.className;
        }
        return valueToReturn;
    }

    handleToggleFilters(){
        this.setState({
            filterSettingsOpen: !this.state.filterSettingsOpen
        });
    }

    handleFilterSubmitClick(selectedDate){
        const { immCard, getBudgetList, setComparativeMonth } = this.props;
        getBudgetList(immCard, selectedDate);
        setComparativeMonth(selectedDate);
    }

    handleRetry() {
        const { immCard } = this.props;
        const firstDayOfCurrentMonth = moment().startOf('month').format(DATE_FORMAT_API);
        this.props.getBudgetList(immCard, firstDayOfCurrentMonth);
    }

    generateBudgetCard(immBudgetCategory) {
        const { cardId, history } = this.props;
        const categoryName = immBudgetCategory.get('category');
        const budgetValue = immBudgetCategory.get('budget');
        let expenseValue = immBudgetCategory.get('expense');

        if(expenseValue > 0){
            expenseValue = 0;
        } else {
            expenseValue = Math.abs(expenseValue);
        }

        const categoryIconClassName = getCategoryIcon(categoryName);
        const categroyExpenseBudgetRatioIndicator = this.determineColorClassForExpenseBudgetRatio(budgetValue, expenseValue);
        return (
            <li
                key={categoryName}
                className={`open-young-budget__category open-young-budget__category--expense-${categroyExpenseBudgetRatioIndicator}`}
                onClick={() => {
                    history.push(`/myprofile/cards/${cardId}/budgets/expenses-by-category/${categoryName}/${BY_BUDGETS}`);
                }}>
                <div className="open-young-budget__category-graph">
                    <ComparativeCircle
                        baseValue={budgetValue}
                        inputValue={expenseValue}
                    />
                    <i className={`open-young-budget__category-icon ${categoryIconClassName}`}/>
                </div>
                <FormattedText
                    value={`categories-${categoryName}`}
                    className="open-young-budget__categroy-name"
                />
                <div className="open-young-budget__categroy-budget-expense-compare">
                    <span className="open-young-budget__categroy-budget-amount">
                        {currencyHelper.formatAmount(expenseValue)} {EURO_SYMBOL}
                    </span>
                    <FormattedText
                        value={"openYoungBudgets-compareOf"}
                        className="open-young-budget__categroy-budget-expense-separator"
                    />
                    <span className="open-young-budget__categroy-expense-amount">
                        {currencyHelper.formatAmount(budgetValue)} {EURO_SYMBOL}
                    </span>
                </div>
            </li>
        );
    }

    render() {
        const { immBudgetExpense, getBudgetList } = this.props;
        let bodyContent;
        const immBudgetCategories = immBudgetExpense.getIn(['budgetList','incomeExpense']);
        const current_month = moment(this.props.selectedMonth).format('MMMM');

        if (immBudgetExpense.get('isFetching')) {
            bodyContent = <LoadingSection />;

        } else if(immBudgetExpense.get('isError')){
            const lostConnectionErrorTitle = formatText('openYoungBudget-errorTitle');
            const lostConnectionErrorMessage = formatText('openYoungBudget-errorMessage');
            const retryButton = (
                <OKButton
                    className="open-young-budget__retry-button"
                    onClick={this.handleRetry}
                >
                    <FormattedText value="openYoungBudget-retry" />
                </OKButton>
            );
            bodyContent = <EmptyState primaryText={lostConnectionErrorTitle}  secondaryText={lostConnectionErrorMessage} button={retryButton} iconType="nointernet-banking"/>

        } else {
            let content;
            if(immBudgetCategories && immBudgetCategories.size === 0){
                const noBudgetsMessage = formatText('openYoungBudget-noBudgetsMessage');
                content = <EmptyState primaryText={noBudgetsMessage} iconType="search-banking"/>

            } else if(immBudgetCategories && immBudgetCategories.size > 0){

                const budgetCategoryList = immBudgetCategories.reduce((list, immBudgetCategory) => {
                    if(immBudgetCategory.get('budget') > 0){
                        list.push(this.generateBudgetCard(immBudgetCategory));
                    }
                    return list;
                }, []);

                if(budgetCategoryList.length > 0){
                    content = (
                        <ul className="open-young-budget__categories">
                            {budgetCategoryList}
                        </ul>
                    );
                } else {
                    const noBudgetsMessage = formatText('openYoungBudget-noBudgetsMessage');
                    content = <EmptyState primaryText={noBudgetsMessage} iconType="search-banking"/>
                }
            }
            bodyContent = (
                <section className="open-young-budget">
                    <div className="open-young-budget__filters">
                        <span className="open-young-budget__comaparative-month-icon"></span>
                        <span className="open-young-budget__comaparative-month">
                            {formatText('openYoungBudgetFilter-comparativeMonth')} {current_month}</span>
                        <OKButton modifier="task" onClick={this.handleToggleFilters}>
                            <i className="icon icon-filtrar open-young-budget__filter-settings-icon" />
                        </OKButton>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative">
                                <div className="col-md-12">
                                    <OpenYoungCardBudgetFilter
                                        getBudgetList={getBudgetList}
                                        isOpen={this.state.filterSettingsOpen}
                                        onCloseClick={this.handleToggleFilters}
                                        onFilterSubmitClick={this.handleFilterSubmitClick}
                                        selectedMonth={this.props.selectedMonth}
                                        type="filter"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {content}
                </section>
            );
        }
        return bodyContent;
    }
}

OpenYoungCardBudget.propTypes = {
    cardId: PropTypes.string.isRequired,
    getBudgetList: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immBudgetExpense: PropTypes.object.isRequired,
    immCard: PropTypes.object.isRequired,
    setComparativeMonth: PropTypes.func.isRequired,
    selectedMonth: PropTypes.string,
};

module.exports = withRouter(OpenYoungCardBudget);
